import React from 'react';
import { Modal, Text, Space } from '@good/ui/core';
import { useTranslation } from 'react-i18next';

type ConfimModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmModal = ({ isOpen, onClose, onConfirm }: ConfimModalProps) => {
  const { t } = useTranslation('', { keyPrefix: 'accountManagement.payPeriodPage.confirmModal' });
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={t('heading')}
      size='md'
      confirmProps={{
        label: t('confirm'),
        onClick: onConfirm,
        'aria-label': 'Submit',
      }}
      cancelProps={{
        label: t('cancel'),
        onClick: onClose,
        'aria-label': 'Cancel',
      }}
    >
      <Text>{t('description1')} </Text>
      <Space h='md' />
      <Text>{t('description2')}</Text>
    </Modal>
  );
};
